<template lang="pug">
  .choice-audience
    v-list-item-title.mb-1 Настройка аудитории
    v-list-item-subtitle Выберите для кого будет проводиться конференция
    template(v-if="value.commited")
      v-row(
        no-gutters
        align="center"
      ).mt-5
        v-icon(size=50 color="secondary lighten-1") mdi-account-group-outline
        .ml-3
          span {{ AUDIENCE_TYPE_LABEL[value.type] }}
          .caption Участники
      template(v-if="value.courses.length")
        v-list.my-2.sdo-radius
          v-subheader Курсы
          v-list-item(
            v-for="course in value.courses"
            :key="course.id"
          ).my-2
            v-list-item-avatar
              v-img(
                :src="course.image_file_url || require('@/assets/course-sample.png')"
              )
            v-list-item-content
              v-list-item-subtitle {{ course.title }}
      template(v-if="value.enrollments.length")
        v-list.sdo-radius.my-2
          v-subheader Наборы
          v-list-item(
            v-for="record in value.enrollments"
            :key="record.id"
          ).my-2
            v-list-item-avatar
              v-avatar(color="secondary lighten-1").caption.white--text {{ record.code }}
            v-list-item-content
              v-list-item-subtitle
                | {{ record.start_learning | dp('d MMMM y') }} -
                |  {{ record.end_learning | dp('d MMMM y') }}
                .caption.opacity Период обучения

      template(v-if="value.groups.length")
        v-list.sdo-radius
          v-subheader Группы
          v-list-item(
            v-for="(group, idx) in value.groups"
            :key="group.id"
            :value="group"
          ).my-2
            v-list-item-avatar
              v-avatar(
                color="secondary lighten-1"
              ).caption.white--text {{ idx + 1 }}
            v-list-item-content
              v-list-item-subtitle {{ group.short_name }}

    template(v-if="!value.commited")
      v-btn-toggle(
        v-model="audienceType"
      ).mt-3.grey.lighten-5.fill-width
        v-btn(
          :value="AUDIENCE_TYPE.students"
        ).px-5
          span Для обучающихся
        v-btn(
          :value="AUDIENCE_TYPE.all"
        ).px-5
          span Для всех

      .mt-5(v-if="audienceType === AUDIENCE_TYPE.students")
        select-list-course(
          v-model="courses.selected"
          :items="courses.items"
          multiple
          :loading="loading.courses"
        )

        v-expand-transition
          select-list-enrollment(
            v-if="selectedCourse"
            v-model="enrollments"
            :items="selectedCourse.prior_records"
            multiple
          )

        template(v-if="selectedCourse")
          v-expand-transition
            select-list-group(
              v-if="selectedEnrollment"
              v-model="groups.selected"
              :items="groups.items"
              multiple
            )

      .mt-5
        v-btn(
          v-if="canCommit"
          color="grey lighten-3"
          depressed
          :disabled="loading.courses || loading.groups"
          @click="commitValue"
        ) Продолжить
</template>

<script>
import SelectListCourse from '@/components/InputFields/course/SelectListCourse.vue';
import SelectListEnrollment from '@/components/InputFields/enrollment/SelectListEnrollment.vue';
import SelectListGroup from '@/components/InputFields/group/SelectListGroup.vue';

const AUDIENCE_TYPE = {
  students: 1,
  all: 2,
};

const AUDIENCE_TYPE_LABEL = {
  [AUDIENCE_TYPE.students]: 'Для обучающихся',
  [AUDIENCE_TYPE.all]: 'Все',
};

export default {
  components: {
    SelectListCourse,
    SelectListEnrollment,
    SelectListGroup,
  },
  props: {
    value: { type: Object, default: () => ({ commited: false }) },
  },
  data() {
    return {
      AUDIENCE_TYPE,
      AUDIENCE_TYPE_LABEL,

      audienceType: null,

      courses: {
        items: [],
        selected: [],
      },
      enrollments: [],
      groups: {
        items: [],
        selected: [],
      },

      loading: {
        courses: false,
        enrollments: false,
        groups: false,
      },
    };
  },
  computed: {
    selectedCourse() {
      if (this.courses.selected.length > 1) return null;
      const [course] = this.courses.selected;
      return course;
    },
    selectedEnrollment() {
      if (this.enrollments.length > 1) return null;
      const [enrollment] = this.enrollments;
      return enrollment;
    },
    selectedGroup() {
      if (this.groups.selected.length > 1) return null;
      const [group] = this.groups.selected;
      return group;
    },
    canCommit() {
      return !!this.audienceType;
    },
  },
  watch: {
    audienceType() {
      this.courses.selected = [];
      this.enrollments = [];
      this.groups.selected = [];
      if (!this.courses.items.length) {
        this.fetchCourses();
      }
    },
    selectedCourse(val) {
      this.enrollments = [];
      this.groups.selected = [];
      if (val) this.fetchGroups();
    },
    selectedEnrollment(val) {
      this.groups.selected = [];
      if (val) this.fetchGroups();
    },
  },
  methods: {
    async fetchCourses() {
      this.loading.courses = true;
      const { items } = await this.$api.courses.index(
        {
          // 'search[has_active_prior_records]': true,
          'search[teacher_or_curator]': this.$user.data.id,
          expand: 'prior_records,course_units',
        },
      );
      this.courses.items = items;
      this.loading.courses = false;
    },
    async fetchGroups() {
      this.loading.groups = true;
      const response = await this.$api.groups.getGroupList({
        'search[course_id]': this.selectedCourse.id,
      });
      this.groups.items = response.data.data;
      this.loading.groups = false;
    },
    commitValue() {
      let courses = this.courses.selected;
      let { enrollments } = this;
      let groups = this.groups.selected;

      // Select all if not the one picked
      if (this.audienceType === AUDIENCE_TYPE.students) {
        if (this.selectedEnrollment && this.groups.selected < 1) {
          groups = this.groups.items;
        }
        if (this.selectedCourse && this.enrollments < 1) {
          enrollments = this.selectedCourse.prior_records;
        }
        if (this.courses.selected < 1) {
          courses = this.courses.items;
        }
      }

      this.$emit('input', {
        type: this.audienceType,
        courses,
        enrollments,
        groups,
        is_open: this.audienceType === AUDIENCE_TYPE.all,

        commited: true,
      });
    },
  },
};
</script>
